import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FormikForm } from "components/FormikForm/FormikForm";
import { FileCompleteDocuments } from "./FileCompleteDocuments";
import { FileUploadValues } from "./updateTaskPrice";
import { TaskCompletedDocuments } from "types/Models/task";
import { addFilingCompleteDocumentValidation } from "formValidations/addFilingCompleteDocumentValidation";

type DelawareFranchiseTaxModalProps = {
  show: boolean;
  onClose: () => void;
  isUpdatingTaxAmount: boolean;
  uploadTaskCompletedFile: (values: FileUploadValues) => void;
  showNotes: boolean;
  showAmount: boolean;
  completedDocuments: TaskCompletedDocuments[];
  amount: string;
  groupId: string;
};

export const TaskCompleteModal = ({
  show,
  onClose,
  isUpdatingTaxAmount,
  uploadTaskCompletedFile,
  showNotes,
  showAmount,
  completedDocuments,
  amount,
  groupId,
}: DelawareFranchiseTaxModalProps) => {
  const getDefaultInitialValues = (
    completedDocuments: TaskCompletedDocuments[]
  ) =>
    completedDocuments.length > 0
      ? completedDocuments.map((doc) => ({
          file: {
            name: doc.name,
            type: doc.file_type,
            uuid: doc.uuid,
          },
          docType: doc.document_type_tag,
          uuid: null,
        }))
      : [
          {
            file: null,
            docType: "",
            uuid: null,
          },
        ];

  const defaultInitialValues = getDefaultInitialValues(completedDocuments);
  const validationSchema = addFilingCompleteDocumentValidation(showAmount);

  return (
    <Modal.Root open={show} onOpenChange={onClose}>
      <Modal.Content useCustomOverlay asChild>
        <FormikForm
          validationSchema={validationSchema}
          onSubmit={(values) => uploadTaskCompletedFile(values)}
          initialValues={{
            amount: amount,
            notes: "",
            files: defaultInitialValues,
          }}
        >
          {({ submitForm }) => {
            return (
              <>
                <Modal.Header>
                  <Modal.Title>Update Filing</Modal.Title>
                  <Modal.Close type="button" onClick={onClose} />
                </Modal.Header>
                <Modal.Body className="t-space-y-4">
                  {showAmount && (
                    <TextInput
                      block
                      name="amount"
                      type="number"
                      placeholder="Enter amount"
                      label="Amount"
                      required
                    />
                  )}
                  {showNotes && (
                    <TextArea
                      name="notes"
                      label="Description"
                      rows={5}
                      placeholder="Enter description"
                    />
                  )}
                  <FileCompleteDocuments groupId={groupId} />
                </Modal.Body>
                <Modal.FooterButtonGroup>
                  <Modal.RawClose asChild>
                    <Button type="button">Cancel</Button>
                  </Modal.RawClose>
                  <Button
                    isLoading={isUpdatingTaxAmount}
                    customType="primary"
                    onClick={submitForm}
                    type="submit"
                    disabled={isUpdatingTaxAmount}
                  >
                    Confirm & Submit
                  </Button>
                </Modal.FooterButtonGroup>
              </>
            );
          }}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
